import { render } from "./RepairScreen.vue?vue&type=template&id=496af359&scoped=true"
import script from "./RepairScreen.vue?vue&type=script&lang=js"
export * from "./RepairScreen.vue?vue&type=script&lang=js"

import "./RepairScreen.vue?vue&type=style&index=0&id=496af359&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/jb/jb-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-496af359"]])

export default __exports__